import {
  customPatternWithNumbers,
  guidEmpty,
  removeAcento,
  schoolingOptions,
} from './../../../../../utils/helps';
import { OptionModel } from './../../../../services/models/model';
import { ApplicantDependentModel } from '../../../../services/models/hiring/applicantDependent.model';
import { DatePipe } from '@angular/common';
import { ApplicantService } from 'services/hiring/applicant.service';
import { GeographyService } from '../../../../services/geography.service';
import { Component, EventEmitter, OnInit, Output, ElementRef, Input } from '@angular/core';
import { ApplicantFormModel } from '../../../../services/models/hiring/applicantForm.model';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormGroup,
} from '@angular/forms';
import { FormValidations } from 'utils/form-validation';
import { comparer, customPattern, omit_special_char } from 'utils/helps';
import { ActivatedRoute } from '@angular/router';
import { filter, finalize, map, startWith, switchMap, tap } from 'rxjs/operators';
import { HiringConfigModel } from 'services/models/hiring/hiringConfig.model';
import FieldVisibility from 'services/enums/fieldVisibility.enum';
import { DomainService } from 'services/domain.service';
import { ShirtSizeEnum } from 'services/enums/ShirtSize.enum';
import { forkJoin, Observable, timer } from 'rxjs';
import { StateModel } from 'services/models/state.model';
import { CountryModel } from 'services/models/country.model';
import { DistrictModel } from 'services/models/district.model';
import { ApplicantOcrDocumentModel } from 'services/models/hiring/applicant-ocr-document.model';
import { OcrFieldStyleService } from './ocr-field-style.service';

@Component({
  selector: 'app-admission-form-base',
  templateUrl: './admission-form-base.component.html',
  styleUrls: ['./admission-form-base.component.scss'],
  providers: [OcrFieldStyleService],
})
export class AdmissionFormBaseComponent implements OnInit {
  @Input() hiringConfig: HiringConfigModel | null = null;
  @Input() applicant: ApplicantFormModel | null = null;
  @Input() dependents: ApplicantDependentModel[] = [];
  @Input() applicantForm: ApplicantFormModel | null = null;
  @Input() ocrData: ApplicantOcrDocumentModel[] = [];

  @Output() changedSexEvent: EventEmitter<any> = new EventEmitter();
  @Output() changedDependentEvent: EventEmitter<any> = new EventEmitter();
  @Output() formValidEvent: EventEmitter<any> = new EventEmitter();

  error = false;
  cpf = '';
  applicantId = '';
  form = new UntypedFormGroup({});
  dependentsform = new UntypedFormGroup({});
  states: StateModel[] = [];
  places: DistrictModel[] = [];
  countries: CountryModel[] = [];
  streetTypeOptions: OptionModel[] = [];
  bankOptions: OptionModel[] = [];
  customizedBankOptions: OptionModel[] = [{ value: 'BSC', label: `BSC - BS-CASH` }];
  isStranger = false;
  stateSelected = '';
  dependentNumber = 0;
  omitChar = omit_special_char;
  compareValues = comparer;
  removeSpecialCharacter = removeAcento;
  pattern = customPattern;
  numberPattern = customPatternWithNumbers;
  datePipe = new DatePipe('pt-BR');
  isLoading = false;
  schoolingOptions = schoolingOptions;
  shirtSizeOptions = ShirtSizeEnum.buildListEnum().map(item => (item as ShirtSizeEnum).toOption());
  formReady = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private geographyService: GeographyService,
    private _applicantService: ApplicantService,
    private _route: ActivatedRoute,
    private el: ElementRef,
    private _domainService: DomainService,
    private ocrFieldStyleService: OcrFieldStyleService
  ) { }

  ngOnInit() { }

  public startComponent(disable: boolean): void {
    this.setLoadSpinner(true);

    forkJoin({
      streetTypes: this.loadStreetTypes(),
      countries: this.loadCountries(),
      states: this.loadStates(),
      banks: this.loadBanks(),
    })
      .pipe(
        tap(() => this.initializeForm()),
        switchMap(() => this.settleApplicantFields$()),
        tap(() => {
          if (disable) this.form.disable();
        }),

        tap(() => this.initializeFormDependents()),
        switchMap(() => this.settleApplicantDependentsFields$()),
        tap(() => {
          if (disable) {
            timer(1500).subscribe(() => this.dependentsform.disable());
          }
        }),
        tap(() => this.listinerFieldsChanges()),
        finalize(() => {
          this.setLoadSpinner(false);
          this.captureInitialFormValues();
        })
      )
      .subscribe({
        next: () => this.formValidEvent.emit(),
        error: err => {
          this.setLoadSpinner(false);
          console.error('Erro ao iniciar o componente:', err);
        },
      });
  }

  settleApplicantFields$(): Observable<void> {
    return timer(1500).pipe(
      tap(() => {
        this.applicant.formatDates();
        this.dependentNumber = this.applicant.dependentNumber;
        const ctpsNumber =
          this.applicant.ctpsNumber && this.applicant.ctpsNumber.trim() !== ''
            ? this.applicant.ctpsNumber
            : this.applicant.cpf.slice(0, 7);
        const ctpsSerie =
          this.applicant.ctpsSerie && this.applicant.ctpsSerie.trim() !== ''
            ? this.applicant.ctpsSerie
            : this.applicant.cpf.slice(7, 11);
        const bankNumber =
          this.applicant.bankNumber && this.applicant.bankNumber.trim() !== ''
            ? this.applicant.bankNumber
            : this.hiringConfig.bankNumbers[0];

        this.form.patchValue({
          ...this.applicant,
          applicantId: this.applicant.id,
          nationality: this.geographyService.defaultCountry,
          ctpsNumber,
          ctpsSerie,
          bankNumber,
        });
      }),
      map(() => void 0)
    );
  }

  settleApplicantDependentsFields$(): Observable<void> {
    return timer(1700).pipe(
      tap(() => {
        this.dependentsFrmArray.controls.forEach((frmGrp, i) => {
          const dependent = ApplicantDependentModel.create(this.applicant.dependents[i]);
          dependent.formatDates();
          this.applicant.dependents[i] = dependent;
          frmGrp.patchValue(dependent);
        });
      }),
      map(() => void 0)
    );
  }

  setLoadSpinner(state: boolean) {
    this.isLoading = state;
  }

  loadStreetTypes(): Observable<any> {
    return this._domainService
      .getStreetTypeOptions(this.hiringConfig.usesOCR)
      .pipe(tap(res => (this.streetTypeOptions = res.data)));
  }

  loadCountries() {
    return this.geographyService
      .getCountries(this.hiringConfig.usesOCR)
      .pipe(tap(res => (this.countries = res.data)));
  }

  loadStates(): Observable<any> {
    return this.geographyService
      .getStates(this.hiringConfig.usesOCR)
      .pipe(tap(res => (this.states = res.data)));
  }

  loadBanks(): Observable<any> {
    return this.geographyService.getBanks().pipe(
      tap(bank => {
        const listAllBanks = !this.hiringConfig.bankNumbers?.filter(x => x && x.trim()).length;

        const fetchedBankOptions = bank.data
          .filter(x => listAllBanks || this.hiringConfig.bankNumbers.includes(x.code.toString()))
          .map(x => ({ value: x.code.toString(), label: `${x.code} - ${x.fullName}` }));

        const customizedBankOptions = this.customizedBankOptions
          .filter(x => listAllBanks || this.hiringConfig.bankNumbers.includes(x.value))
          .map(x => ({ value: x.value, label: x.label }));

        this.bankOptions = [...fetchedBankOptions, ...customizedBankOptions];
      })
    );
  }

  listinerFieldsChanges() {
    this.cepChanged();
    this.sexChanged();
    this.dependentChanged();
    this.ufChanged();
    this.strangerChecked();
  }

  cepChanged() {
    const field = this.form.get('zipCode') as UntypedFormControl;
    field.valueChanges.subscribe((cep: string) => {
      if (cep.length === 8 && this.applicant.zipCode !== cep) {
        this.geographyService.search(cep).subscribe(({ data }) => {
          const log = this.removeSpecialCharacter(data.logradouro);
          const neigh = this.removeSpecialCharacter(data.bairro);
          const cit = this.removeSpecialCharacter(data.localidade);
          const address = {
            street: log,
            neighborhood: neigh,
            city: cit,
            state: data.uf,
          };
          this.form.patchValue(address);
        });
      }
    });
  }

  sexChanged() {
    const field = this.form.get('sex') as UntypedFormControl;
    field.valueChanges.subscribe((sex: number) => {
      this.applicant.sex = sex;
      if (this.applicant.sex == 1) {
        this.form.get('militaryDischarge').setValidators([Validators.required]);
        this.form.get('militaryDischarge').updateValueAndValidity();
      } else {
        this.form.get('militaryDischarge').clearValidators();
        this.form.get('militaryDischarge').updateValueAndValidity();
      }
      this.changedSexEvent.emit(this.applicant);
    });
  }

  dependentChanged() {
    const field = this.form.get('dependentNumber') as UntypedFormControl;
    field.valueChanges.subscribe((dependents: number) => {
      this.applicant.dependentNumber = dependents;
      this.dependentNumber = dependents;
      this.initializeFormDependents();
      this.changedDependentEvent.emit(this.applicant);
    });
  }

  ufChanged() {
    this.birthStateField.valueChanges
      .pipe(
        startWith(this.birthStateField.value),
        filter(state => typeof state === 'string' && state.length === 2 && !this.isStranger),
        tap(() => this.setLoadSpinner(true)),
        switchMap(state => this.geographyService.getDistrictsByState(state))
      )
      .subscribe(res => {
        this.places = res.data;
        const foundPlace = this.places.find(x => x.name === this.applicant.birthplace);
        this.birthPlaceField.setValue(foundPlace ? foundPlace.name : null);
        this.birthPlaceField.updateValueAndValidity();
        this.birthPlaceField.markAsTouched();
        this.setLoadSpinner(false);
      });
  }

  strangerChecked() {
    const field = this.form.get('stranger') as UntypedFormControl;
    field.valueChanges.subscribe((stranger: boolean) => {
      this.isStranger = field.value;
      if (this.isStranger) {
        this.birthPlaceField.clearValidators();
        this.birthStateField.clearValidators();
      } else {
        this.birthPlaceField.setValidators(Validators.required);
        this.birthStateField.setValidators(Validators.required);
      }
    });
  }

  initializeForm() {
    this.form = this.formBuilder.group({
      birthDate: ['', [Validators.required]],
      maritalStatus: ['', [Validators.min(1)]],
      sex: [3, [Validators.min(1)]],
      socialName: ['', [Validators.maxLength(70)]],
      dependentNumber: ['', [Validators.maxLength(3)]],
      racialDistinction: [8],
      schooling: [35],
      fathersName: [''],
      mothersName: ['', [Validators.minLength(5), Validators.required]],
      bankNumber: [this.hiringConfig.bankNumbers[0]],
      bankAgency: [''],
      bankAccountNumber: [''],
      bankAccountDigit: [''],
      nationality: [this.geographyService.defaultCountry],
      stranger: [false],
      birthplace: ['', [Validators.required]],
      birthState: [''],
      streetType: [''],
      zipCode: [''],
      street: [''],
      addressComplement: ['', [Validators.maxLength(80)]],
      city: [''],
      state: [''],
      neighborhood: [''],
      houseNumber: [''],
      email: ['', [Validators.required, Validators.email]],
      shoeSize: [0],
      shirtSize: [''],
      pantsSize: [0],
      contact1: ['', [Validators.required]],
      emergencyName: ['', [Validators.maxLength(80)]],
      emergencyKinship: ['', [Validators.maxLength(50)]],
      emergencyEmail: ['', [Validators.email]],
      emergencyContact: [''],
      electoralCard: ['', [Validators.minLength(6)]],
      electoralSection: [''],
      electoralZone: [''],
      cpf: [{ value: this.applicant.cpf, disabled: true }, [Validators.required]],
      rg: ['', [Validators.minLength(6), Validators.required]],
      rgIssuer: [''],
      rgState: [''],
      rgDate: [''],
      pis: ['', [Validators.minLength(10), FormValidations.pisValidator]],
      ctpsNumber: [this.applicant.cpf.slice(0, 7), [Validators.minLength(7)]],
      ctpsSerie: [this.applicant.cpf.slice(7, 11), [Validators.minLength(4)]],
      ctpsState: [''],
      ctpsIssueDate: [null],
      militaryDischarge: [''],
      applicantId: [this.applicant.id],
    });

    this.setFieldValidators();

    if (this.hiringConfig.usesOCR) {
      this.form.get('dependentNumber').disable();
      this.form.get('dependentNumber').updateValueAndValidity();
    }
  }

  setFieldValidators(): void {
    const conditionalRequiredFields = ['militaryDischarge'];
    const fieldsConfig = JSON.parse(this.hiringConfig.setAdmissionForm);

    Object.entries(this.form.controls).forEach(([field, control]) => {
      if (!control) return;

      if (this.isFieldRequired(field, conditionalRequiredFields, fieldsConfig)) {
        const validators = control.validator
          ? [Validators.required, control.validator]
          : [Validators.required];
        control.setValidators(validators);
      }
    });

    this.form.updateValueAndValidity();
    this.formReady = true;
  }

  initializeFormDependents() {
    this.dependentsform = this.formBuilder.group({
      dependents: this.formBuilder.array([]),
    });

    const existingDependents = this.applicant?.dependents ?? [];
    const total = this.dependentNumber;

    // 1. Adiciona os dependentes existentes
    for (const dep of existingDependents) {
      const dependentForm = this.createDependentForm(dep);
      this.applyDynamicValidators(dependentForm);
      this.dependentsFrmArray.push(dependentForm);
    }

    // 2. Completa com formulários em branco até atingir dependentNumber
    const missing = total - existingDependents.length;

    for (let i = 0; i < missing; i++) {
      const dependentForm = this.createDependentForm(); // vazio
      this.applyDynamicValidators(dependentForm);
      this.dependentsFrmArray.push(dependentForm);
    }
  }

  private createDependentForm(dependent?: ApplicantDependentModel): FormGroup {
    const dependentForm = this.formBuilder.group({
      birthDate: [dependent?.birthDate ?? '', [Validators.required]],
      sex: [dependent?.sex ?? 0, [Validators.required, Validators.min(1)]],
      cpf: [dependent?.cpf ?? '', [Validators.maxLength(11), FormValidations.cpf, this.duplicateCpf()]],
      name: [dependent?.name ?? '', [Validators.required]],
      kinshipDegree: [dependent?.kinshipDegree ?? '', [Validators.maxLength(2), Validators.min(1)]],
      applicantId: [this.applicant.id, [Validators.required]],
      familySalaryType: [dependent?.familySalaryType ?? 3],
      incomeReportType: [dependent?.incomeReportType ?? 4],
      id: [dependent?.id ?? guidEmpty],
    });

    dependentForm.get('cpf')?.valueChanges.subscribe(() => {
      this.dependentsFrmArray.controls.forEach(otherDependent => {
        if (otherDependent !== dependentForm) {
          otherDependent.get('cpf')?.updateValueAndValidity({
            onlySelf: true,
            emitEvent: false,
          });
        }
      });
    });

    return dependentForm;
  }

  private applyDynamicValidators(dependentForm: FormGroup) {
    const groupConfig = JSON.parse(this.hiringConfig.setAdmissionForm);

    Object.entries(dependentForm.controls).forEach(([field, control]) => {
      if (!control) return;

      if (this.isFieldRequired(field, [], groupConfig)) {
        const validators = control.validator
          ? [Validators.required, control.validator]
          : [Validators.required];

        control.setValidators(validators);
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  isFieldRequired(
    field: string,
    conditionalFields: string[],
    fieldsConfig: Record<string, FieldVisibility>
  ): boolean {
    if (conditionalFields.includes(field)) return false;
    const groupHasFieldConfig = field in fieldsConfig;
    return groupHasFieldConfig ? fieldsConfig[field] === FieldVisibility.Required : true;
  }

  get dependentsFrmArray(): UntypedFormArray {
    return this.dependentsform.controls['dependents'] as UntypedFormArray;
  }

  duplicateCpf(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      if (this.applicant?.cpf === value) {
        return { duplicateCpf: true };
      }

      const isDuplicate = this.dependentsFrmArray.controls.some(dependentForm => {
        const cpfControl = dependentForm.get('cpf');

        if (cpfControl === control) {
          return false;
        }

        return cpfControl?.value === value;
      });

      return isDuplicate ? { duplicateCpf: true } : null;
    };
  }

  isFieldVisible(field: string): boolean {
    const fieldsConfig = JSON.parse(this.hiringConfig.setAdmissionForm || '{}');
    const groupHasFieldConfig = field in fieldsConfig;
    return groupHasFieldConfig ? fieldsConfig[field] !== FieldVisibility.Hidden : true;
  }

  public captureInitialFormValues(): void {
    if (this.hiringConfig.usesOCR && this.ocrData) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        if (!control) return;
        this.ocrFieldStyleService.setInitialFieldValue(field, control.value, true, null);
      });
      this.dependentsFrmArray.controls.forEach(frmGrp => {
        const dependentId = frmGrp.get('id')?.value ?? null;
        Object.keys((frmGrp as FormGroup).controls).forEach(field => {
          const control = frmGrp.get(field);
          if (!control) return;
          this.ocrFieldStyleService.setInitialFieldValue(field, control.value, false, dependentId);
        });
      });
    }
  }

  onChangeDependentNumber() {
    this.initializeFormDependents();
  }

  public getOcrFieldSourceText(
    fieldName: string,
    isApplicantField: boolean = true,
    dependentId?: string | null
  ): string {
    return this.ocrFieldStyleService.getOcrFieldSourceText(
      this.ocrData,
      this.hiringConfig?.usesOCR ?? false,
      fieldName,
      isApplicantField,
      dependentId
    );
  }

  public isFieldFilledByOcr(
    fieldName: string,
    isApplicantField: boolean = true,
    dependentId?: string | null
  ): boolean {
    return this.ocrFieldStyleService.isFieldFilledByOcr(
      this.ocrData,
      this.hiringConfig?.usesOCR ?? false,
      fieldName,
      isApplicantField,
      dependentId
    );
  }

  public shouldShowOcrIcon(
    fieldName: string,
    isApplicantField: boolean = true,
    dependentId?: string | null,
    explicitCurrentValue?: any
  ): boolean {
    if (isApplicantField) {
      const control = this.form.get(fieldName);
      const currentValue = control ? control.value : explicitCurrentValue;
      return this.ocrFieldStyleService.shouldShowOcrIcon(
        this.ocrData,
        this.hiringConfig?.usesOCR ?? false,
        fieldName,
        currentValue,
        true,
        null
      );
    }

    return this.ocrFieldStyleService.shouldShowOcrIcon(
      this.ocrData,
      this.hiringConfig?.usesOCR ?? false,
      fieldName,
      explicitCurrentValue,
      false,
      dependentId
    );
  }

  /**
   * Estado único (cor + ícone) para o campo, usando sempre o mesmo currentValue.
   * Garante que ícone e cor mudem juntos quando o usuário alterar o valor.
   */
  public getOcrFieldState(
    fieldName: string,
    isApplicantField: boolean = true,
    dependentId?: string | null,
    explicitCurrentValue?: any
  ): { classes: { [key: string]: boolean }; showIcon: boolean } {
    const currentValue = isApplicantField
      ? (this.form.get(fieldName)?.value ?? undefined)
      : explicitCurrentValue;
    const state = this.ocrFieldStyleService.getOcrFieldDisplayState(
      this.ocrData,
      this.hiringConfig?.usesOCR ?? false,
      fieldName,
      isApplicantField,
      dependentId,
      currentValue
    );
    return {
      classes: { 'field-ocr-filled': state.fieldOcrFilled },
      showIcon: state.showIcon,
    };
  }

  public getOcrFieldClasses(
    fieldName: string,
    isApplicantField: boolean = true,
    dependentId?: string | null,
    explicitCurrentValue?: any
  ): { [key: string]: boolean } {
    return this.getOcrFieldState(fieldName, isApplicantField, dependentId, explicitCurrentValue)
      .classes;
  }

  get birthStateField() {
    return this.form.get('birthState') as UntypedFormControl;
  }

  get birthPlaceField() {
    return this.form.get('birthplace') as UntypedFormControl;
  }
}
